var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1934 5.12842C18.1934 4.39725 17.6008 3.80688 16.8724 3.80688C16.1439 3.80688 15.5508 4.39725 15.5508 5.12842C15.5508 5.85689 16.1439 6.44727 16.8724 6.44727C17.6008 6.44727 18.1934 5.85689 18.1934 5.12842Z",
    fill: "url(#paint0_linear_6639_8522)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9527 15.4444C19.9037 16.517 19.7243 17.0997 19.5754 17.4868C19.3753 18 19.1367 18.3669 18.7497 18.7518C18.3669 19.1367 18 19.3748 17.4868 19.5727C17.0997 19.7238 16.5148 19.9038 15.4422 19.9549C14.2827 20.006 13.9391 20.0169 10.9986 20.0169C8.06089 20.0169 7.71457 20.006 6.55502 19.9549C5.48248 19.9038 4.90025 19.7238 4.51316 19.5727C3.99728 19.3748 3.63306 19.1367 3.24818 18.7518C2.86056 18.3669 2.62192 18 2.42458 17.4868C2.2756 17.0997 2.09351 16.517 2.04728 15.4444C1.99077 14.2849 1.98041 13.9358 1.98041 11.0014C1.98041 8.0609 1.99077 7.71458 2.04728 6.55502C2.09351 5.48248 2.2756 4.90026 2.42458 4.5099C2.62192 3.99728 2.86056 3.63249 3.24818 3.24761C3.63306 2.86329 3.99728 2.62461 4.51316 2.42459C4.90025 2.27291 5.48248 2.09568 6.55502 2.04459C7.71457 1.99346 8.06089 1.98042 10.9986 1.98042C13.9391 1.98042 14.2827 1.99346 15.4422 2.04459C16.5148 2.09568 17.0997 2.27291 17.4868 2.42459C18 2.62461 18.3669 2.86329 18.7497 3.24761C19.1367 3.63249 19.3753 3.99728 19.5754 4.5099C19.7243 4.90026 19.9037 5.48248 19.9527 6.55502C20.0065 7.71458 20.0195 8.0609 20.0195 11.0014C20.0195 13.9358 20.0065 14.2849 19.9527 15.4444ZM21.9331 6.4648C21.8793 5.29273 21.6944 4.49197 21.4199 3.79452C21.1405 3.07094 20.7659 2.45773 20.1527 1.84452C19.5423 1.23405 18.9291 0.859474 18.2055 0.576801C17.5053 0.304976 16.7072 0.117954 15.5346 0.0668678C14.362 0.0103168 13.9875 0 10.9986 0C8.0125 0 7.63523 0.0103168 6.46263 0.0668678C5.29272 0.117954 4.49522 0.304976 3.79179 0.576801C3.07094 0.859474 2.45773 1.23405 1.84725 1.84452C1.23404 2.45773 0.859472 3.07094 0.57733 3.79452C0.305504 4.49197 0.120685 5.29273 0.0641342 6.4648C0.013047 7.6374 0 8.0125 0 11.0014C0 13.9875 0.013047 14.362 0.0641342 15.5346C0.120685 16.7045 0.305504 17.5047 0.57733 18.2055C0.859472 18.9263 1.23404 19.5423 1.84725 20.1527C2.45773 20.7632 3.07094 21.1405 3.79179 21.4227C4.49522 21.6945 5.29272 21.8793 6.46263 21.9331C7.63523 21.987 8.0125 22 10.9986 22C13.9875 22 14.362 21.987 15.5346 21.9331C16.7072 21.8793 17.5053 21.6945 18.2055 21.4227C18.9291 21.1405 19.5423 20.7632 20.1527 20.1527C20.7659 19.5423 21.1405 18.9263 21.4199 18.2055C21.6944 17.5047 21.8793 16.7045 21.9331 15.5346C21.9869 14.362 22 13.9875 22 11.0014C22 8.0125 21.9869 7.6374 21.9331 6.4648Z",
    fill: "url(#paint1_linear_6639_8522)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9982 14.6653C8.97427 14.6653 7.33198 13.0257 7.33198 11.0018C7.33198 8.97459 8.97427 7.33287 10.9982 7.33287C13.0227 7.33287 14.6671 8.97459 14.6671 11.0018C14.6671 13.0257 13.0227 14.6653 10.9982 14.6653ZM10.9982 5.34972C7.87832 5.34972 5.35156 7.8819 5.35156 11.0018C5.35156 14.1189 7.87832 16.6484 10.9982 16.6484C14.1181 16.6484 16.6475 14.1189 16.6475 11.0018C16.6475 7.8819 14.1181 5.34972 10.9982 5.34972Z",
    fill: "url(#paint2_linear_6639_8522)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6639_8522",
    x1: 0.199373,
    y1: 21.7724,
    x2: 20.1686,
    y2: 1.80328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501119,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950079,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6639_8522",
    x1: 0.198437,
    y1: 21.7999,
    x2: 20.184,
    y2: 1.81436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501119,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950079,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6639_8522",
    x1: 0.203175,
    y1: 21.8009,
    x2: 20.1839,
    y2: 1.82014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501119,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950079,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.194d20e9b6197ab7f6d6ee91930e3607.svg";
export { ForwardRef as ReactComponent };